import React, {Component} from 'react';

export default class RichTextContent extends Component {
  /** @function
   * Renders the Rich Text Content component.
   */
  render() {
    var html = {__html: this.props.html};
    return <div dangerouslySetInnerHTML={html} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/content/rich-text-content.js